import { IVectorLayerGroupConfig } from "esdm-map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import { IMappingTextPack, IMap } from "esdm-map";
import { HbsmrUser } from "./HbsmrUser";
import { BuckinghamshireRecordType, BuckinghamshireRecordSubType } from "./BuckinghamshireRecordTypes";


export class MapBase {

    constructor(    
        protected mappingTextPack: IMappingTextPack,
        protected user: HbsmrUser) {        
    }

    protected isAuthenticated = (): boolean => {
        return this.user !== null;
    }

    protected filterMapLayers = (layerGroupConfig: Array<IVectorLayerGroupConfig> ): Array<IVectorLayerGroupConfig> => {
        if (!this.isAuthenticated()) {
            //remove layers that require authentication
            return layerGroupConfig.filter(function (value, index, arr) {
                let authlayers = (
                    value.type === BuckinghamshireRecordType.Consultation ||
                    value.type === BuckinghamshireRecordType.Event
                    );
                return !authlayers;
            });
        } else {
            return layerGroupConfig;
        }
    }    

    protected setWmsOpactity = (map: IMap): void => {
        let wmslayers: string[];
        wmslayers = [BuckinghamshireRecordType.HistoricRidgeAndFurrow, BuckinghamshireRecordType.Hlc_1820, BuckinghamshireRecordType.Hlc_1880, BuckinghamshireRecordType.Hlc_2000];

        map.options.layerGroupCollection.wmsLayerGroups.forEach(lg => {
            if (wmslayers.indexOf(lg.layerType) > -1) {
                lg.layers.forEach(lyr => {
                    lyr.olWmsLayer.setOpacity(0.7);
                });
            }
        });
    }
}